// removed by extract-text-webpack-plugin
module.exports = {"paginationPanel":"paginationPanel__1oIOy","totalText":"totalText__2D7rw","changeSizeOuterWrapper":"changeSizeOuterWrapper__1ufi2","button":"button__3nwuu","leftButton":"leftButton__17mzJ","rightButton":"rightButton__3tmZu","pagainationWrapper":"pagainationWrapper__1_SvS","changeSizeWrapper":"changeSizeWrapper__wp79d","pageSize":"pageSize__2NCbH","changeSizeBtnWrapper":"changeSizeBtnWrapper__33iIj","changeSizeBtn":"changeSizeBtn__3uW0h","pageSizeModal":"pageSizeModal__2zfKE","pagination":"pagination__3iciz"};


//////////////////
// WEBPACK FOOTER
// ./components/paginationPanel/style.scss
// module id = qnaA
// module chunks = 22